export const createCookie = (name, value, days) => {
  if (typeof window !== 'undefined' && window.document) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    }

    const theName = encodeURIComponent(name);
    const theValue = encodeURIComponent(value);
    window.document.cookie = theName + '=' + theValue + expires + '; path=/';
  }
};

export function readCookie(name) {
  if (typeof window !== 'undefined' && window.document) {
    const nameEQ = encodeURIComponent(name) + '=';
    const ca = window.document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {c = c.substring(1, c.length);}
      if (c.indexOf(nameEQ) === 0) {return decodeURIComponent(c.substring(nameEQ.length, c.length));}
    }
  }

  return null;
}
